(() => {
    'use strict';
    const root = document.querySelector('[data-quick-search]');
    if (!root) return;
    const tabs = [...root.querySelectorAll('[data-quick-tab]')];
    const panels = [...root.querySelectorAll('[data-quick-panel]')];
    const tablist = root.querySelector('[data-quick-tabs]');
    const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(next, true);
        });
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
    });
    root.querySelectorAll('[data-quick-more]').forEach((button) => {
        const panel = button.closest('[data-quick-panel]');
        panel.classList.add('collapsed');
        button.hidden = false;
        button.addEventListener('click', () => {
            const expanded = panel.classList.toggle('collapsed') === false;
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? 'Свернуть' : 'Показать все';
        });
    });
    tablist.setAttribute('role', 'tablist');
    tablist.hidden = false;
    root.classList.add('enhanced');
    activate(0);
})();
